// src/components/AudioManager.js
import React, { forwardRef, useImperativeHandle, useRef } from 'react';

const AudioManager = forwardRef((props, ref) => {
  const refs = {
    luckySpinMove: useRef(),
    luckySpinFinish: useRef(),
    btnClick: useRef(),
    btnMisclick: useRef(),
    reward: useRef(),
    coinsFly: useRef(),
    gotCoins: useRef(),
    gotTon: useRef(),
    gotTicket: useRef(),
    notification: useRef(),
    progressRefill: useRef(),
    convertation: useRef(),
    popup: useRef(),
  };

  useImperativeHandle(ref, () => ({
    play: (key) => {
      const audio = refs[key]?.current;
      if (audio) {
        audio.currentTime = 0;
        audio.play().catch(err => {
          console.warn(`AudioManager: Failed to play "${key}"`, err);
        });
      }
    },
    stop: (key) => {
      const audio = refs[key]?.current;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    },
    loop: (key) => {
      const audio = refs[key]?.current;
      if (audio) {
        audio.loop = true;
        audio.currentTime = 0;
        audio.play().catch(err => {
          console.warn(`AudioManager: Failed to loop "${key}"`, err);
        });
      }
    }
  }));

  return (
    <>
      <audio ref={refs.luckySpinMove} src="/LuckySpinMove.mp3" preload="auto" />
      <audio ref={refs.luckySpinFinish} src="/LuckySpinFinish.mp3" preload="auto" />
      <audio ref={refs.btnClick} src="/BtnClickUi.mp3" preload="auto" />
      <audio ref={refs.btnMisclick} src="/BtnMisclickUi.mp3" preload="auto" />
      <audio ref={refs.reward} src="/RewardShowing.mp3" preload="auto" />
      <audio ref={refs.coinsFly} src="/CoinsFlyEarn.wav" preload="auto" />
      <audio ref={refs.gotCoins} src="/GotCoins.mp3" preload="auto" />
      <audio ref={refs.gotTon} src="/GotTon.mp3" preload="auto" />
      <audio ref={refs.gotTicket} src="/GotTicket.mp3" preload="auto" />
      <audio ref={refs.notification} src="/Notification.mp3" preload="auto" />
      <audio ref={refs.progressRefill} src="/ProgressRefill.mp3" preload="auto" />
      <audio ref={refs.convertation} src="/Convertation.mp3" preload="auto" />
      <audio ref={refs.popup} src="/PopupOpenClose.mp3" preload="auto" />
    </>
  );
});

export default AudioManager;
